module.exports = __webpack_public_path__ + "static/media/scan.a536974a.png";